export const CHECKOUT_FORM = 'checkout-form';
export interface StateWithCheckoutForm {
  [CHECKOUT_FORM]: CheckoutFormsState;
}

export interface CheckoutFormsState {
  formsObjectValue: any;
}
